import script from "./ParceriasPrexDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParceriasPrexDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ParceriasPrexDashboard.vue?vue&type=style&index=0&id=33dee63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dee63a"]])

export default __exports__